import apiClient from '../../../api/client';
import type {
  PlanResponse,
  CreatePlanDto,
  UpdatePlanDto,
  QueryPlanesDto,
  Paginated,
} from '@aid/shared';

export type { PlanResponse, CreatePlanDto, UpdatePlanDto, QueryPlanesDto };

export async function getPlanes(params: QueryPlanesDto): Promise<Paginated<PlanResponse>> {
  const { data } = await apiClient.get<Paginated<PlanResponse>>('/admin/planes', { params });
  return data;
}

export async function getPlan(id: number): Promise<PlanResponse> {
  const { data } = await apiClient.get<PlanResponse>(`/admin/planes/${id}`);
  return data;
}

export async function createPlan(dto: CreatePlanDto): Promise<PlanResponse> {
  const { data } = await apiClient.post<PlanResponse>('/admin/planes', dto);
  return data;
}

export async function updatePlan(id: number, dto: UpdatePlanDto): Promise<PlanResponse> {
  const { data } = await apiClient.patch<PlanResponse>(`/admin/planes/${id}`, dto);
  return data;
}

export async function deletePlan(id: number): Promise<void> {
  await apiClient.delete(`/admin/planes/${id}`);
}
